import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { SegmentHeaderContainerModel } from '../../../../../../models/aggregates/dgmkt/dgmkt-segment';

@Injectable({
  providedIn: 'root',
})
export class DgMktSegmentHeaderService extends BaseApiTemplateService<SegmentHeaderContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'segments-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'segments-hdrs';
    this.endpoint_path =
      Core2Config.DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'segments-hdrs';
    this.httpClient = http;
  }
}
